import { useTranslation, Trans } from 'react-i18next'
import { FC } from 'react'
import PerText from '../../../../components/custom_components/Text'
import { PerModal } from '../../../../components/custom_components/Modal'
import { ActiveHrBusinessPartnerDto } from '../../../../types'
import { computeFullname } from '../../../../shared/nameDisplayPreferencesUtil'
import { useAuth } from '../../../../context/auth-context'

export interface DeleteHRBPRelationModalProps {
  relation: ActiveHrBusinessPartnerDto
  onClose: () => void
  onSubmit: () => Promise<void>
  deletionInProgress: boolean
  deletionError?: string
}

export const DeleteHRBPRelationModal: FC<DeleteHRBPRelationModalProps> = ({
  relation,
  onClose,
  onSubmit,
  deletionInProgress,
  deletionError,
}) => {
  const { user } = useAuth()
  const [t] = useTranslation()

  return (
    <PerModal
      centered
      visible={!!relation}
      onCancel={onClose}
      title={{
        heading: t('companySettingsView.hrBusinessPartnersTab.deletionModal.heading'),
      }}
      footer={{
        confirmBtn: {
          onClick: async () => {
            await onSubmit()
          },
          disabled: deletionInProgress,
          isProcessing: { active: deletionInProgress },
        },
        cancelBtn: { onClick: onClose },
      }}
    >
      <Trans
        i18nKey="companySettingsView.hrBusinessPartnersTab.deletionModal.description"
        values={{
          employeeName: computeFullname(user.nameDisplayPreference, relation.employee.firstName, relation.employee.lastName),
          companyName: relation.companyName,
        }}
        components={[<b></b>]}
      />

      {deletionError !== undefined && (
        <>
          <PerText mt="xs" color="error">
            {t('companySettingsView.hrBusinessPartnersTab.deletionModal.deletionError')}
          </PerText>
          {deletionError !== '' && <PerText color="error">{deletionError}</PerText>}
        </>
      )}
    </PerModal>
  )
}
